import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const nav = [
  { to: "/", label: "Home" },
  { to: "/practice-areas", label: "Practice Areas" },
  { to: "/success-stories", label: "Success Stories" },
  { to: "/about", label: "About" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 transition-all duration-300 backdrop-blur-xl ${
        scrolled ? "bg-[#F7F5F0]/85 border-b border-[#0F172A]/10" : "bg-[#F7F5F0]/40 border-b border-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className="font-display text-2xl tracking-tight text-[#0F172A]">EB<span className="text-[#C2A679]">·</span>Immigration</span>
          <span className="hidden md:inline font-mono-plex text-[10px] tracking-[0.24em] uppercase text-[#4A4D50]">Law · Est. 2015</span>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium link-underline ${isActive ? "text-[#0F172A]" : "text-[#4A4D50] hover:text-[#0F172A]"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block">
          <Link to="/case-review" data-testid="nav-cta-case-review" className="btn-primary text-sm !py-3 !px-6">
            Request Case Review
          </Link>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-[#0F172A]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[#0F172A]/10 bg-[#F7F5F0]">
          <div className="container-x py-6 flex flex-col gap-5">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-lg ${isActive ? "text-[#0F172A]" : "text-[#4A4D50]"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/case-review" data-testid="mobile-cta" className="btn-primary text-sm !py-3 !px-6 self-start">
              Request Case Review
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
